// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      workTypeOptions: [
        "B1",
        "B2",
        "M1",
        "M2",
        "O1",
        "O2",
        "P1",
        "P2",
        "S1",
        "S2",
        "T1",
        "T2"
      ],
      // eslint-disable-next-line
      workDriverOptions: [
        "Compliance",
        "Reliability",
        "Safety",
        "Environment",
        "Improve",
        "Reputation",
        "Social"
      ],
      // eslint-disable-next-line
      workThemeOptions: [
        "Check",
        "Inspect",
        "Test",
        "Function",
        "Replace",
        "Repair",
        "Upgrade",
        "Design"
      ],
      // eslint-disable-next-line
      workPlanRiskOptions: [
        "High",
        "Medium",
        "Low"
      ],
      // eslint-disable-next-line
      workFacilityImpactOptions: [
        "Production",
        "Operations",
        "Safety System",
        "Ground Disturbance",
        "High Risk"
      ],
      // eslint-disable-next-line
      workConditionOptions: [
        "OK",
        "Degraded",
        "Failed",
        "Tripped",
        "Damaged"
      ],
      // eslint-disable-next-line
      workResultOptions: [
        "Pass",
        "Fail",
        "NA"
      ],
      // eslint-disable-next-line
      workQualityOptions: [
        "Q0",
        "Q1",
        "Q2",
        "Q3",
        "Q4"
      ],
      // eslint-disable-next-line
      workAuditOptions: [
        "Complete",
        "Partial",
        "Not Started",
        "Not Finished",
        "Issue"
      ],
      // eslint-disable-next-line
      workRiskEscalationOptions: [
        "NA",
        "Trip",
        "Leak",
        "Injury",
        "Expsoure",
        "High Risk"
      ],
      // eslint-disable-next-line
      workShiftOptions: [
        "A",
        "D",
        "N",
        "DN"
      ],
      // eslint-disable-next-line
      workPermitOptions: [
        "Free",
        "Management",
        "Permit",
        "System"
      ]
    };
  }
};
